import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSession, setSession, isPublicPath } from '../session';

const API_BASE = process.env.REACT_APP_API_BASE || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);

// Sessione valida? È il server a dirlo: il token viene verificato al caricamento
// della pagina e poi ogni minuto, aggiornando utente, copia, collegamenti e
// sezioni attive (così una modifica dalla pagina Clienti arriva subito).
export function isAuthenticated() {
    return !!getSession();
}

export default function AuthGate() {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const isPublic = isPublicPath(pathname);

    // Senza sessione, le pagine riservate portano al login.
    useEffect(() => {
        if (isPublic || getSession()) return;
        navigate(`/login?next=${encodeURIComponent(pathname + search)}`, { replace: true });
    }, [pathname, search, isPublic, navigate]);

    // Verifica del token e aggiornamento dati: al caricamento, ogni minuto e
    // subito dopo il login (quando compare una sessione nuova).
    useEffect(() => {
        let timer = null;
        const refresh = () => {
            const s = getSession();
            if (!s) return;
            fetch(`${API_BASE}/api/auth/me`)
                .then(r => (r.ok ? r.json() : null))
                .then(j => {
                    if (!j?.user) return;   // 401 → apiAuth riporta al login
                    const cur = getSession();
                    if (!cur) return;
                    setSession({
                        ...cur, user: j.user, instance: j.instance, links: j.links || [],
                        features: j.features || null, canManageClients: !!j.canManageClients,
                    });
                })
                .catch(() => { /* server non raggiungibile: si riprova */ });
        };
        const start = () => {
            if (timer || !getSession()) return;
            refresh();
            timer = setInterval(refresh, 60000);
        };
        start();
        window.addEventListener('rs-session', start);
        return () => { clearInterval(timer); window.removeEventListener('rs-session', start); };
    }, []);

    return null;
}
